import { Component, OnInit, HostListener } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UnidadeService } from 'src/app/services/unidade.service';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { ColaboradorCadastro } from 'src/app/models/colaborador-cadastro';
import { NgBrazilValidators, MASKS } from 'ng-brazil';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';
import { ParametrosDataService } from 'src/app/services/parametros-data.service';
import { ParametrosKey } from 'src/app/shared/enums/parametros.enum';
import { Unidade } from 'src/app/models/unidade';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Auth } from 'src/app/models/auth';
import { IAngularMyDpOptions } from 'angular-mydatepicker';

import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';

@Component({
    selector: 'app-colaborador-create-lote',
    templateUrl: './colaborador-create-lote.component.html',
    styleUrls: ['./colaborador-create-lote.component.css']
})
export class ColaboradorCreateLoteComponent implements OnInit {
    public get form() { return this.cadastroFormGroup.controls; }
    public get colaboradorControls() { return (this.cadastroFormGroup.controls.Colaboradores as FormArray).controls; }

    constructor(
        private formBuilder: FormBuilder,
        private unidadeService: UnidadeService,
        private colaboradorService: ColaboradorService,
        private parametrosDataService: ParametrosDataService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService
    ) { }
    // form
    public cadastroFormGroup: FormGroup;

    // variáveis
    public cadastros: ColaboradorCadastro[] = [];
    minimumAge = 18;
    private parametros: { [key: string]: string };
    public unidadesList: Unidade[];
    private currentUser: Auth;
    isUnidadeRequired = false;
    public isMobile = false;

    // constantes
    public MASKS = MASKS;
    public myDatePickerOptions: IAngularMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
        minYear: 1901,
        maxYear: 2078,
        monthLabels: {
            0: 'Janeiro',
            1: 'Fevereiro',
            2: 'Março',
            3: 'Abril',
            4: 'Maio',
            5: 'Junho',
            6: 'Julho',
            7: 'Agosto',
            8: 'Setembro',
            9: 'Outubro',
            10: 'Novembro',
            11: 'Dezembro'
        },
        dayLabels: {
            su: 'Dom',
            mo: 'Seg',
            tu: 'Ter',
            we: 'Qua',
            th: 'Qui',
            fr: 'Sex',
            sa: 'Sáb'
        },
        stylesData: {
            selector: 'dp1',
            styles: `
         .dp1 .myDpIconLeftArrow,
         .dp1 .myDpIconRightArrow,
         .dp1 .myDpHeaderBtn {
            color: #6c757d;
         }
         .dp1 .myDpHeaderBtn:focus,
         .dp1 .myDpMonthLabel:focus,
         .dp1 .myDpYearLabel:focus {
            color: #aaa;
         }
         .dp1 .myDpDaycell:focus,
         .dp1 .myDpMonthcell:focus,
         .dp1 .myDpYearcell:focus {
            box-shadow: inset 0 0 0 1px #ccc;
         }
         .dp1 .myDpSelector:focus {
            box-shadow: -1px 1px 6px 0px #bbb;
         }
         .dp1 .myDpSelectorArrow:focus:before {
            border-bottom-color: #bbb;
         }
         .dp1 .myDpCurrMonth,
         .dp1 .myDpMonthcell,
         .dp1 .myDpYearcell {
            color: #6c757d;
         }
         .dp1 .myDpDaycellWeekNbr {
            color: #6c757d;
         }
         .dp1 .myDpPrevMonth,
         .dp1 .myDpNextMonth {
            color: #aaa;
         }
         .dp1 .myDpWeekDayTitle {
            background-color: transparent;
            color: #6c757d;
         }
         .dp1 .myDpHeaderBtnEnabled:hover,
         .dp1 .myDpMonthLabel:hover,
         .dp1 .myDpYearLabel:hover {
            color: #212529;
         }
         .dp1 .myDpMarkCurrDay,
         .dp1 .myDpMarkCurrMonth,
         .dp1 .myDpMarkCurrYear {
            border-bottom: 2px solid #6c757d;
         }
         .dp1 .myDpDisabled {
            color: #999;
         }
         .dp1 .myDpHighlight {
            color: #cd5c5c;
         }
         .dp1 .myDpTableSingleDay:hover,
         .dp1 .myDpTableSingleMonth:hover,
         .dp1 .myDpTableSingleYear:hover {
            background-color: #ccc;
            color: #222;
         }
         .dp1 .myDpRangeColor {
            background-color: #eee;
         }
         .dp1 .myDpSelectedDay,
         .dp1 .myDpSelectedMonth,
         .dp1 .myDpSelectedYear {
            background-color: #ccc;
            color: #222;
         }
       `
        }
    };
    dateMask = MaskedDate;
    //#endregion

    // helper
    inDocumento: string;

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        this.isMobile = window.innerWidth <= 500;
    }
    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.isUnidadeRequired = this.getUnityRequirement();
        this.loadViewConfig();
        this.loadLists();
        this.createForm(this.cadastros);
    }

    loadViewConfig() {
        this.parametros = this.parametrosDataService.currentParametrosValue;
        if (this.parametros) {
            if (this.parametros[ParametrosKey.idadeMinimaColaborador]) {
                this.minimumAge = +this.parametros[ParametrosKey.idadeMinimaColaborador];
            }
        }
    }

    getUnityRequirement(): boolean {
        if (
            this.parametrosDataService.currentParametrosValue &&
            this.parametrosDataService.currentParametrosValue[
            ParametrosKey.exigirUnidadeCadastroColaborador
            ]
        ) {
            return JSON.parse(
                this.parametrosDataService.currentParametrosValue[
                ParametrosKey.exigirUnidadeCadastroColaborador
                ]
            );
        }
        return false;
    }

    loadLists() {
        this.unidadeService
            .getAll(this.currentUser.token.assignorGuid)
            .subscribe(response => {
                this.unidadesList = response.result;
            });
    }

    //#region Form
    createForm(cadastros: ColaboradorCadastro[]) {
        this.cadastroFormGroup = this.formBuilder.group({
            Colaboradores: new FormArray([])
        });
    }
    //#endregion

    onSubmit(cadastros: any) {

        if (this.cadastroFormGroup.valid) {
            if (cadastros) {
                if (cadastros.Colaboradores) {
                    // formatar data
                    cadastros.Colaboradores.forEach(colaboradorCadastro => {
                        if (colaboradorCadastro.dataNascimento) {
                            if (colaboradorCadastro.dataNascimento.singleDate.date) {
                                colaboradorCadastro.dataNascimento = new Date(
                                    colaboradorCadastro.dataNascimento.singleDate.date.year,
                                    colaboradorCadastro.dataNascimento.singleDate.date.month -
                                    1,
                                    colaboradorCadastro.dataNascimento.singleDate.date.day
                                );
                            }
                        }

                        if (colaboradorCadastro.documento) {
                            colaboradorCadastro.documento = colaboradorCadastro.documento.replace(/\D+/g, '').replace(' ', '');
                        }
                    });

                    this.colaboradorService.addLote(cadastros.Colaboradores, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
                        response => {
                            if (response.status === ApiError.Sucesso) {
                                this.alertService.success(response.message);
                            } else {
                                this.alertService.error(response.message);
                            }
                        }, error => {
                            this.alertService.error(error.error);
                        }
                    );

                    cadastros.Colaboradores.forEach(colaboradorCadastro => {
                        colaboradorCadastro.dataNascimento = { isRange: false, singleDate: { jsDate: colaboradorCadastro.dataNascimento } };
                    });
                }
            }
        } else {
            GenericValidator.verifierValidatorsForm(this.cadastroFormGroup);
        }
    }

    //#region Manipulação Form Array Colaboradores
    addColaborador() {
        const formGroup = new FormGroup({
            // mesmas propriedaddes do create
            documento: new FormControl('', [
                Validators.required,
                NgBrazilValidators.cpf
            ]),
            nome: new FormControl('', [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            sobrenome: new FormControl('', [
                Validators.required,
                Validators.minLength(3),
                Validators.maxLength(100)
            ]),
            unidadeId: new FormControl(),
            dataNascimento: new FormControl(
                '',
                [
                    Validators.required
                ]
            ),

            // salvar '' senão da erro na base
            email: new FormControl(''),
            matricula: new FormControl(''),
            nomeMae: new FormControl(''),
            nomePai: new FormControl(''),
            celular: new FormControl(''),

            linhaLote: new FormControl((this.cadastroFormGroup.controls.Colaboradores as FormArray).length + 1)
        });

        if (this.getUnityRequirement()) {
            formGroup.controls.unidadeId.setValidators([
                Validators.required
            ]);
            formGroup.controls.unidadeId.updateValueAndValidity();
        }

        (this.cadastroFormGroup.controls.Colaboradores as FormArray).push(formGroup);
    }

    removeColaborador(index: number) {
        (this.cadastroFormGroup.controls.Colaboradores as FormArray).removeAt(index);
    }
    public CompleteWithZero(value: any) {
        if (!value) { return; }

        const inputValue = value.replace(/\D+/g, '').replace(' ', '');
        let zeros = '';

        for (let i = 0; i < 11 - inputValue.length; i++) { zeros += '0'; }

        value = this.formataCPF(zeros + inputValue);
        return value;
    }

    formataCPF(cpf) {
        return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

}

export function MaskedDate(event: any) {
    const v = event.target.value;
    if (event.keyCode !== 8) {
        if (v.match(/^\d{2}$/) !== null) {
            event.target.value = v + '/';
        } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
            event.target.value = v + '/';
        }
    }
}
